import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MeetingMasterService {

  constructor(private http: HttpClient, private httpService: HttpService) { }

  getMeetingTypeList() {
      var request = {
          URL: 'meetingType/'
      }
      return this.httpService.get(request);
      // return this.http.get(environment.pssUrl + 'meetingType/')
      //     .map(res => res.json());
  }

  getCommitteeMembers(meetingTypeId: string) {

      var request = {
          URL: 'meetingType/committeeMembers/' + meetingTypeId
      }
      return this.httpService.get(request);
  }

  getDirectorOnOtherThenCommitteeMembers() {

      var request = {
          URL: 'directorMaster/Members/null'
      }
      return this.httpService.get(request);
  }

  getInvitteeFromLastBoardMeeting(boardMeetingTypeID) {
      var request = {
          URL: 'meeting/getInvitteeFromLastBoardMeeting/' + boardMeetingTypeID
      }
      return this.httpService.get(request);
  }

  getMeetingTypeNameOnMeetingTypeID(meetingTypeID) {
      var request = {
          URL: 'meetingType/' + meetingTypeID
      }
      return this.httpService.get(request);
  }

  addMeeting(newMeeting) {
      var request = {
          URL: 'meeting',
          DATA: newMeeting
      }
      return this.httpService.post(request);
  }

  /*
      - to delete meeting
      - IsSequenseMeetingNumber pass for automating meeting number functionality
  */
  deleteMeeting(meetingId, IsSequenseMeetingNumber) {

      var headers = new HttpHeaders();
      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)

      return this.http.get(environment.pssServerUrl + 'deleteMeeting/' + meetingId + '/' + IsSequenseMeetingNumber, { headers: headers })
          .map((res) => res);
  }

  getProcessByMeetingType(meetingTypeId: string) {
      var request = {
          URL: 'meetingType/process/' + meetingTypeId
      }
      return this.httpService.get(request);
      // return this.http.get(environment.pssUrl + 'meetingType/process/' + meetingTypeId)
      //     .map(res => res.json());
  }

  getSelectedProcessTask(processID: string) {
      var request = {
          URL: 'predefinedProcessTasks/' + processID
      }
      return this.httpService.get(request);
  }

  getCategoryByMeetingType(meetingTypeId: string) {
      var request = {
          URL: 'categoryMeetingTypeMaster/' + meetingTypeId
      }
      return this.httpService.get(request);
      // return this.http.get(environment.pssUrl + 'categoryMeetingTypeMaster/' + meetingTypeId)
      // .map(res => res.json());
  }

  getPredefinedCommitteeCategoryByMeetingType(meetingTypeId: string) {
      var request = {
          URL: 'predefinedCommitteeCategoryMeetingTypeMaster/' + meetingTypeId
      }
      return this.httpService.get(request);
  }

  getMeetingList(companyID: string) {

      var request = {
          URL: 'meetingType/meetingList/' + companyID
      }
      return this.httpService.get(request);
  }
  getMeetingAgendaList(companyID: string) {

      var request = {
          URL: 'meeting/getMeetingAgendas'
      }
      return this.httpService.get(request);
  }
  getMeetingListByType(meetingTypeID: string) {

      var request = {
          URL: 'meetingType/meetingByMeetingType/' + meetingTypeID,
          DATA: document
      }
      return this.httpService.post(request);
  }

  getMeetingByDate(meetingDate: string) {
      var request = {
          URL: 'meetingType/meetingByMeetingDate/' + meetingDate
      }
      return this.httpService.get(request);
  }

  getMeetingByMeetingTypeAndDate(meeting) {
      var request = {
          URL: 'meetingType/meetingByMeetingTypeAndDate/',
          DATA: meeting
      }
      return this.httpService.post(request);
  }

  addInviteeAttendance(inviteeAttendance, meetingID) {
      var request = {
          URL: 'meetingType/inviteeAttendance/' + meetingID,
          DATA: inviteeAttendance
      }
      return this.httpService.post(request);
  }

  getMeetingDetails(meetingID: string) {
      
      var request = {
          URL: 'meetingType/meetingByMeetingID/' + meetingID
      }
      //return this.httpService.get(request);
      var headers = new HttpHeaders();
      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)
      headers.append('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone); 

      return this.http.get(environment.pssServerUrl + 'meetingType/meetingByMeetingID/' + meetingID, { headers: headers })
          .map(res => res);
  }


  getAgendaByMeetingType(meetingTypeID: string) {
      var request = {
          URL: 'meetingType/agenda/' + meetingTypeID
      }
      return this.httpService.get(request);

      // return this.http.get(environment.pssUrl + 'meetingType/agenda/' + meetingTypeID)
      // .map(res => res.json());
  }

  addDirectorsInmeeting(meetingID, DirectorData) {
      var request = {
          URL: 'meetingType/addDirectors/' + meetingID,
          DATA: DirectorData
      }
      return this.httpService.post(request);

      // var headers = new Headers();
      // headers.append('Content-Type', 'application/json');
      // return this.http.post(environment.pssUrl + 'meetingType/addDirectors/' + meetingID, JSON.stringify(DirectorData), { headers: headers })
      //     .map(res => res.json());
  }

  updateDirector(newMeetingID, directorToUpdate) {

      var request = {
          URL: 'meetingType/updateDirector/' + newMeetingID,
          DATA: directorToUpdate
      }
      return this.httpService.post(request);

      // var headers = new Headers();
      // headers.append('Content-Type', 'application/json');
      // return this.http.put(environment.pssUrl + 'meetingType/updateDirector/' + newMeetingID, JSON.stringify(directorToUpdate), { headers: headers })
      //     .map(response => response.json());
  }

  deleteDirectorInMeeting(meetingID, directorToDeleteById) {
      var request = {
          URL: 'meetingType/deleteDirector/' + meetingID,
          DATA: directorToDeleteById
      }
      return this.httpService.post(request);

      // console.log(directorToDeleteById);      
      // var headers = new Headers();
      // headers.append('Content-Type', 'application/json');
      // return this.http.put(environment.pssUrl + 'meetingType/deleteDirector/' + meetingID,directorToDeleteById, { headers: headers })
      //     .map(response => response.json());
  }

  //added newly
  addAgendaInMeeting(meetingID, agendaData) {
      var request = {
          URL: 'meetingType/addAgenda/' + meetingID,
          DATA: agendaData
      }
      return this.httpService.post(request);
  }

  cloneAgendasToMeeting(targetMeetingId: string, payload: { sourceAgendaIds: string[]; sourceMeetingId?: string }) {
    var request = {
        URL: 'meeting/cloneAgendasToMeeting/' + targetMeetingId,
        DATA: payload
    }
    return this.httpService.post(request);
}


  deleteAgendaInMeeting(meetingID, agendaToDeleteById) {
      var request = {
          URL: 'meetingType/deleteAgenda/' + meetingID,
          DATA: agendaToDeleteById
      }
      return this.httpService.post(request);
      // console.log(agendaToDeleteById);      
      // var headers = new Headers();
      // headers.append('Content-Type', 'application/json');
      // return this.http.put(environment.pssUrl + 'meetingType/deleteAgenda/' + meetingID,agendaToDeleteById, { headers: headers })
      //     .map(response => response.json());
  }

  addCompliancesInMeeting(meetingID, compliancesToAdd) {
      var request = {
          URL: 'meetingType/addCompliance/' + meetingID,
          DATA: compliancesToAdd
      }
      return this.httpService.post(request);

  }

  deleteComplianceInMeeting(meetingID, complianceToDeleteById) {
      console.log(complianceToDeleteById);
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)
      return this.http.post(environment.pssServerUrl + 'meetingType/deleteCompliance/' + meetingID, complianceToDeleteById, { headers: headers })
      .map((response: Response) => response.json()) 
  }


  addInviteesInmeeting(meetingID, meetingInviteesData) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-access-token': localStorage.getItem('token') || ''
    });
  
    return this.http.post(
      environment.pssServerUrl + 'meetingType/addInvitees/' + meetingID,
      meetingInviteesData, // no need to JSON.stringify, HttpClient handles it
      { headers }
    ).pipe(
      map((res: any) => res) // optional; you can also just return directly without this
    );
  }

  updateInvitee(newMeetingID, inviteeObjectToUpdate) {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)
      return this.http.post(environment.pssServerUrl + 'meetingType/updateInvitee/' + newMeetingID, JSON.stringify(inviteeObjectToUpdate), { headers: headers })
      .map((response: Response) => response.json()) 
  }

  deleteInviteeInMeeting(meetingTypeID, meetingID, inviteeToDeleteById) {
      var headers = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      var token = localStorage.getItem('token')
      headers.append("x-access-token", token)
      return this.http.post(environment.pssServerUrl + 'meetingType/deleteInvitee/' + meetingID + '/' + meetingTypeID, inviteeToDeleteById, { headers: headers })
      .map((response: Response) => response.json()) 
  }

  addMembersInmeeting(meetingID, meetingMembersData) {
      var request = {
          URL: 'meetingType/addMembers/' + meetingID,
          DATA: meetingMembersData
      }
      return this.httpService.post(request);
  }

  updateMember(meetingID, memberObjectToUpdate) {
      var request = {
          URL: 'meetingType/updateMember/' + meetingID,
          DATA: memberObjectToUpdate
      }
      return this.httpService.post(request);
  }

  deleteMemberInMeeting(meetingID, MemberToDeleteById) {

      var request = {
          URL: 'meetingType/deleteMember/' + meetingID,
          DATA: MemberToDeleteById
      }
      return this.httpService.post(request);
  }

  addAttendance(meetingID, attendanceData, attendance) {
      var request = {
          URL: 'meetingType/addAttendance/' + meetingID,
          DATA: [{ "data": attendanceData }, { "attendanceRemark": attendance }]
      }
      return this.httpService.post(request);
  }
  addAttendanceDocToMeeting(document, meetingID) {
      var request = {
          URL: 'meetingType/addDocInDMS/' + meetingID,
          DATA: document
      }
      return this.httpService.post(request);
  }
  addATRDocToMeeting(document, meetingID) {
      var request = {
          URL: 'meetingType/addDocInDMSForATR/' + meetingID,
          DATA: document
      }
      return this.httpService.post(request);
  }

  updateDocumentOnly(updatedDocumentManagement) {
      var request = {
          URL: 'meetingType/fileUpateInDMS/',
          DATA: updatedDocumentManagement
      }
      return this.httpService.post(request);
  }

  addFileToMeetingATR(AtrFileData, meetingData) {
      var request = {
          URL: 'meetingType/fileAtrTX/' + meetingData,
          DATA: AtrFileData
      }
      return this.httpService.post(request);

  }
  updateFileInfoToMeetingATR(AtrFileData, meetingData) {
      var request = {
          URL: 'meetingType/fileAtrUpdateTX/' + meetingData,
          DATA: AtrFileData
      }
      return this.httpService.post(request);

  }
  getAgendasBeHalfOfCategory(data) {

      var request = {
          URL: 'agendaOnBehalfOfCategory/',
          DATA: data
      }
      return this.httpService.post(request);
  }

  getMeetingBetweenDates(data) {

      var request = {
          URL: 'meetingType/meetingBetweenDates/',
          DATA: data
      }
      return this.httpService.post(request);
  }

  getAgendaByMeeting(meetingID) {
      var request = {
          URL: 'meeting/getAgenda/' + meetingID
      }
      return this.httpService.get(request);
  }

  //meeting/updateDocumentInMeeting/
  updateDocumentInMeeting(data, meetingID) {

      var request = {
          URL: 'meeting/updateDocumentInMeeting/' + meetingID,
          DATA: data
      }
      return this.httpService.post(request);
  }

  getInCorpDateOfCompany() {
      var request = {
          URL: "companyMaster/getIncorporationdate/"
      }
      return this.httpService.get(request);
  }


  getMeetingOnTypeSelect(meetingTpeID) {
      var request = {
          URL: "meetingType/meetingByMeetingType/" + meetingTpeID,

      }
      return this.httpService.post(request);
  }

  deSelectInvittee(meetingID, inviteeData) {
      var request = {
          URL: "meetingType/addSelectedInvitees/" + meetingID,
          DATA: inviteeData
      }
      return this.httpService.post(request);
  }

  getActivatedTaskList(meetingID) {
      var libraryTasklistAdmin = JSON.parse(localStorage.getItem("resources")).some(function (o) { return o["Menu"] === "ActivatedTaskAll"; })
      var request = {
          URL: "meeting/getActivatedTasksOnMeetingID/" + meetingID + "/" + libraryTasklistAdmin
      }
      return this.httpService.get(request);
  }


  sendNotifcationToUsers(userInformation) {
      // console.log('userInformation', userInformation)
      var request = {
          URL: "notifications/meeting/" + userInformation.Type,
          DATA: userInformation
      }
      return this.httpService.post(request)
  }

  addCategoryAndAgendaInMeeting(categoryData, meetingID) {
      var request = {
          URL: "meeting/AddCategoryAndAgendaAlsoActivateTask/" + meetingID,
          DATA: categoryData
      }
      return this.httpService.post(request)
  }

  deleteCategoryFromMeeting(categoryData, meetingId) {
      var request = {
          URL: "meeting/removeCategoryAndAgendaAlsoDeactivateTask/" + meetingId,
          DATA: categoryData
      }
      return this.httpService.post(request)
  }

  reOrderingOfAgendaArray(data, meetingId) {
      var request = {
          URL: "meeting/reOrderingOfAgendaArray/" + meetingId,
          DATA: data
      }
      return this.httpService.post(request)
  }

  serchMeetingForDataTable(searchedData) {
      var request = {
          URL: "meeting/dataTable/",
          DATA: searchedData
      }
      return this.httpService.post(request)
  }

  authonticateDataForComapnay(data) {
      var request = {
          URL: "authorise/moduleElement",
          DATA: data
      }
      return this.httpService.post(request)
  }

  agendaGenerationFileUpdateInDB(data) {
      var request = {
          URL: "meeting/Update/AgendaGenerationDoc",
          DATA: data
      }
      return this.httpService.post(request)
  }

  readMeetingDockletFile(meetingID) {
      var request = {
          URL: "viewDocketDocFile/" + meetingID,
      }
      return this.httpService.get(request)
  }

  getAgendaGenerationData(meetingID, companyName) {
      var request = {
          URL: "getAgendaGenerationData/" + meetingID + "/" + companyName,
          skipLoader: true,
      }
      return this.httpService.get(request)
  }

  getUserOnId(id) {
      var request = {
          URL: "user/getUserByUserId/" + id,
      }
      return this.httpService.get(request);
  }

  agendaGenerationPdfFileUpdateInDB(data) {
      var request = {
          URL: "meeting/Update/AgendaGenerationPdf",
          DATA: data
      }
      return this.httpService.post(request)
  }

  getAgendaAttachmentData(meetingID, agendaId) {
      var request = {
          URL: "getAgendaByMeetingAndAgendaId/" + meetingID + "/" + agendaId,
      }
      return this.httpService.get(request)
  }

  agendaGenerationRemovePdfFile(meetingID, agendaId, pdfId, documentId) {
      var request = {
          URL: "removePdfAttachment/" + meetingID + "/" + agendaId + "/" + pdfId + "/" + documentId,
      }
      return this.httpService.get(request)
  }

  addConsolidatedFile(data) {
      var request = {
          URL: "meeting/Update/AgendaGenerationDocxUpdate",
          DATA: data
      }
      return this.httpService.post(request)
  }

  generateConsolidatedFile(meetingId) {
      var request = {
          URL: "meeting/generateConsolidatedDocx/" + meetingId,
      }
      return this.httpService.get(request)
  }

  generateConsolidatedPdf(meetingId) {
      var request = {
          URL: "meeting/generateConsolidatedPdf/" + meetingId,
      }
      return this.httpService.get(request)
  }

  getSplittedAgendaDocxData(meetingId) {
      var request = {
          URL: "meeting/getDocxSplittedDataByMeetingId/" + meetingId,
      }
      return this.httpService.get(request)
  }

  saveSplittedAgendaInMeeting(meetingId, meetingTypeId, splitDataId, data) {
      var request = {
          // URL: "meeting/saveSplittedAgendaInMeeting",
          URL: "meeting/saveSplittedAgendaInMeeting/" + meetingId + "/" + meetingTypeId + "/" + splitDataId,
          DATA: data
      }
      return this.httpService.post(request)
  }

  deleteSplittedAgendaDocxData(id) {
      var request = {
          URL: "meeting/deleteSplittedDataFromSplitModel/" + id,
      }
      return this.httpService.get(request)
  }

  addAgendaTemplateFile(data, companyId) {
      var request = {
          URL: "meeting/addAgendaTemplateFile/" + companyId,
          DATA: data
      }
      return this.httpService.post(request)
  }

  getAgendaTemplateData(companyId) {
      var request = {
          URL: "meeting/getAgendaTemplateByCompanyId/" + companyId,
      }
      return this.httpService.get(request)
  }
  getCommitteeMemberForMeeting(committeeID) {
      var request = {
          URL: 'committee/getComitteeMemberForMeeting/' + committeeID
      }
      return this.httpService.get(request);
  }

  // addConsolidatedFile(data){
  //     var request = {
  //         URL: "meeting/Update/AgendaGenerationDocx",
  //         DATA: data
  //     }
  //     return this.httpService.post(request)
  // }

  publishAgendaToGem(data, meetingId) {
      var request = {
          URL: "meeting/publishAgenda/" + meetingId,
          DATA: data
      }
      return this.httpService.post(request)
  }

  hideMeetingFromGem(meetingId, meetingGemStatus) {
      var request = {
          URL: 'meeting/hideMeetingFromGem/' + meetingId + '/' + meetingGemStatus
      }
      return this.httpService.get(request);
  }

  transferPdfToGem(meetingId) {
      var request = {
          URL: 'meeting/transferPdfToGem/' + meetingId
      }
      return this.httpService.post(request);
  }

  /* (09-04-2019) */

  freezeMeeting(meetingId, meetingFreezeStatus) {
      var request = {
          URL: 'meeting/freezeMeeting/' + meetingId + '/' + meetingFreezeStatus
      }
      return this.httpService.get(request);
  }

  /* (10-04-2019) */
  getAgendaAccessRights(meetingId) {
      var request = {
          URL: 'meeting/getAgendaAccessRights/' + meetingId
      }
      return this.httpService.get(request);
  }

  updateAgendaAccess(meetingId, data) {
      var request = {
          URL: 'meeting/updateAgendaAccess/' + meetingId,
          DATA: data
      }
      return this.httpService.post(request);
  }

  generateNoticeFile(meetingId) {
      var request = {
          URL: "meeting/generateNoticeFile/" + meetingId,
      }
      return this.httpService.get(request)
  }
  addIndexTemplateFile(data, companyId) {
      var request = {
          URL: "meeting/addIndexTemplateFile/" + companyId,
          DATA: data
      }
      return this.httpService.post(request)
  }

  renumberAgenda(data, meetingId) {
      var request = {
          URL: "meeting/renumberAgenda/" + meetingId,
          DATA: data
      }
      return this.httpService.post(request)
  }
  downloadAgendaFile(meetingID, docId, fileName) {
      var token = localStorage.getItem('token')
      window.location.href = environment.pssServerUrl + "meeting/download/" + meetingID + "/" + docId + "/" + fileName + "/" + token;
  }

  downloadSplitFailureFile(fileName) {
      var token = localStorage.getItem('token')
      window.location.href = environment.pssServerUrl + "meeting/splitErrorFileDownload/" + fileName + "/" + token;
  }

  generateMinutesDocument(meetingId) {
      var request = {
          URL: "meeting/generateMinutesDocument/" + meetingId,
      }
      return this.httpService.get(request)
  }

  minutesFileUpdateInDB(data) {
      var request = {
          URL: "meeting/Update/minutesDocUpdate",
          DATA: data
      }
      return this.httpService.post(request)
  }



  logout() {
      var request = {
          URL: 'userMaster/logOut'
      }
      return this.httpService.getGovEvaCallLogout(request)
  }
  sortAgendaGroup(meetingId) {
      var request = {
          URL: "meeting/sortAgendaGroup/" + meetingId,
      }
      return this.httpService.get(request)
  }
  getCategoryMasterDataByCatId(categoryId) {
      var request = {
          URL: 'categoryMasterByCategoryId/' + categoryId
      }
      return this.httpService.get(request);
  }

  updateAgendaFiles(meetingId) {
      var request = {
          URL: "meeting/updateAgendaFiles/" + meetingId,
      }
      return this.httpService.get(request)
  }
  getAgendaByID(agendaID: string) {
      var request = {
          URL: "getAgendaById/" + agendaID
      }
      return this.httpService.get(request)
  }
  generateKeyBeforDownloadingDocument(meetingId, agendaId, type) {
      // var request = {
      //     URL: "replaceKeyData/" + meetingId + "/" + agendaId,
      // }
      // return this.httpService.get(request)
      var token = localStorage.getItem('token')
      window.location.href = environment.pssServerUrl + "replaceKeyData/" + meetingId + "/" + agendaId + "/" + type + "/" + token;
  }
  private handleError(error: any): Promise<any> {
      console.error('An error occurred', error); // for demo purposes only
      return Promise.reject(error.message || error);
  }

  getAttendanceFileName(fileId) {
      const url = environment.PSSFileNotValidurl + "documentManagement/getFileNameByID/" + fileId;

      return this.http.get(url).toPromise()
          .then((response: any) => {
              return Promise.resolve(response=>response.json());
          })
          .catch(this.handleError);
  }
  // Call for automatic meeting number
  getMeetingNumberByMeetingType(meetingTypeId: string, Meetingdate,MeetingTime) {
      var request = {
          URL: 'meetingNumberByMeetingType/' + meetingTypeId + '/' + Meetingdate+'/'+MeetingTime
      }
      return this.httpService.get(request);
  }

  getProcessandAgendabyMeetingId(meetingId) {
      var request = {
          URL: 'getProcessandAgendabyMeetingId/' + meetingId
      }
      return this.httpService.get(request);
  }

  getAgendaSpecificProcess(meetingId, agendaId) {
      var request = {
          URL: 'getAgendaSpecificProcess/' + meetingId + '/' + agendaId
      }
      return this.httpService.get(request);
  }

  getFilteredCompliance(meetingId, agendaId, processId) {
      var request = {
          URL: 'getFilteredComplianceFromMeeting/' + meetingId + '/' + agendaId + '/' + processId
      }
      return this.httpService.get(request);
  }


  //Calling deleteFromDirectory to delete the file from directory and DocumentManagement collection
  deleteFromDirectory(docID, meetingID, isDeleteFromAgendaFileRequired,deleteOrigin) {
      
      let deleteFileData:any = {};
      deleteFileData["docID"] =docID;
      deleteFileData["meetingID"] =meetingID;
      deleteFileData["isDeleteFromAgendaFileRequired"] =isDeleteFromAgendaFileRequired; 
      deleteFileData["deleteOrigin"] =deleteOrigin; 

      var request = {
          URL: "documentManagement/deleteFromDirectory",
          DATA: deleteFileData
          // URL: "getAgendaGenerationData/" + meetingID
      }
      return this.httpService.post(request)
  }

  // Agenda Voting Methods
  
  /**
   * Submit a vote for an agenda (Approve or Reject)
   */
  submitAgendaVote(voteData) {
      var request = {
          URL: 'agendaVote/submit',
          DATA: voteData
      }
      return this.httpService.post(request);
  }

  /**
   * Get vote summary for a specific agenda
   * Includes approve/reject counts and current user's vote
   */
  getAgendaVoteSummary(meetingID: string, agendaID: string) {
      var request = {
          URL: 'agendaVote/summary/' + meetingID + '/' + agendaID
      }
      return this.httpService.get(request);
  }

  /**
   * Get vote summary for all agendas in a meeting
   */
  getMeetingVoteSummary(meetingID: string) {
      var request = {
          URL: 'agendaVote/meeting/' + meetingID
      }
      return this.httpService.get(request);
  }

  /**
   * Retract/delete user's vote
   */
  retractAgendaVote(meetingID: string, agendaID: string) {
      var request = {
          URL: 'agendaVote/retract/' + meetingID + '/' + agendaID
      }
      return this.httpService.delete(request);
  }

  submitMinuteVote(voteData) {
      var request = {
          URL: 'minuteVote/submit',
          DATA: voteData
      }
      return this.httpService.post(request);
  }

  getMinuteVoteSummary(meetingID: string, minuteType: string) {
      var request = {
          URL: 'minuteVote/summary/' + meetingID + '/' + minuteType
      }
      return this.httpService.get(request);
  }

  getMeetingMinuteVoteSummary(meetingID: string) {
      var request = {
          URL: 'minuteVote/meeting/' + meetingID
      }
      return this.httpService.get(request);
  }

  retractMinuteVote(meetingID: string, minuteType: string) {
      var request = {
          URL: 'minuteVote/retract/' + meetingID + '/' + minuteType
      }
      return this.httpService.delete(request);
  }
}